<template>
  <div id="help">
    <call />
    <pop-alert />
    <!-- header -->
    <top-bar title="ヘルプ" backUrl="/"/>
    <!-- main -->
    <main>
      <footer-app page="top" :loading="loading"></footer-app>
      <section>
        <div class="l-main--bg-border l-main--bg-border--pink">
          <div class="l-main__body mt-16 p-16">
            <div class="l-check-cart">
              <router-link to="/tutorial?from-page=help" class="c-btn-base c-btn--ct-left box-center mb-8">
                このアプリでできること
              </router-link>
              <router-link to="/help/login" class="c-btn-base c-btn--ct-left box-center mb-8" >
                アカウント連携
              </router-link>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import PopAlert from "../components/PopAlert.vue";
import TopBar from "../components/TopBar.vue";

export default Vue.extend({
  name: "Help",
  components: {
    "footer-app": Footer,
    PopAlert,
    TopBar,
  },
  mixins: [Tenant],
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
      this.loading = false;
    },
  },
});
</script>
